import axios from '../../utils/axios';

export const patientPurchasedOfTariff = (servicePackageId: string) => {
  return axios.post(`/api/v1/servicepackages/my/buy/${servicePackageId}`);
};
